import { getInternalBuyerMeetings } from '@/services/booking';
import { IState } from '@/state/IState';
import { setBuyerMeetings } from './actions';
import { Dispatch } from 'redux';

export function loadBuyerMeetings() {
    return async function (dispatch: Dispatch, getState: () => IState) {
        const residentialUnitId = getState().buyer.permissions!.residentialUnitId;
        dispatch(setBuyerMeetings(await getInternalBuyerMeetings(residentialUnitId)));
    };
}
